import { useState, useEffect } from 'react'

// Único punto de verdad del breakpoint móvil del panel.
// matchMedia dispara solo al cruzar el umbral (no en cada píxel de resize).
export function useIsMobile(maxWidth = 768) {
  const query = `(max-width: ${maxWidth}px)`
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  )

  useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = (e) => setIsMobile(e.matches)
    mql.addEventListener('change', onChange)
    setIsMobile(mql.matches) // sincroniza por si el umbral cambió
    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return isMobile
}